module.exports = __webpack_public_path__ + "static/img/title_bg_1.da695e0d.jpg";